import { Button, Menu, MenuItem, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import keycloak from 'src/utils/commonMethods/keycloak'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import { getLoggedInUserData } from 'src/services/individualService'
import { showNotificationMessage, userinfo } from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { FETCH_USER_NOTIFICATION } from 'src/utils/constants/AppConstants'
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from 'src/utils/commonMethods/encryptDecrypt'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { COLORS } from 'src/utils/Themes/colors'

const LinkedCompanies = ({ childOptions }) => {
  const { token } = keycloak
  const classes = useStyles()
  const isFirstRender = useRef(true)
  const dispatch = useDispatch()
  const user = useSelector((state) => state?.userInfo)
  const [anchorEl, setAnchorEl] = useState(null)
  const child = getSessionStorageItem('sub-client')

  const fetchChildUserData = async () => {
    const response = await getLoggedInUserData(token, child)

    try {
      const responseUserInfo = {
        userData: {
          ...response?.res?.data,
          parentClientId: response?.res?.data?.clientId,
          clientId:
            response?.res?.data?.corporateAdminFor ||
            response?.res?.data?.clientId,
        },
      }
      dispatch(userinfo(responseUserInfo))
    } catch (err) {
      let num = response?.res?.data?.status
      if (400 <= num && num <= 499) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FETCH_USER_NOTIFICATION?.TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FETCH_USER_NOTIFICATION?.PLEASE_RELOAD_TRY_AGAIN,
          })
        )
      }
    }
  }

  const handleMenuOpen = (event) => {
    setAnchorEl(event?.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    fetchChildUserData()
    // eslint-disable-next-line
  }, [child])

  return (
    <div className={classes.linkedCompaniesMainContainer}>
      <div className={classes.childsDropdownContainer}>
        {childOptions?.length > 0 && (
          <Button
            id='childView'
            className={classes.buttonUploadPersonal}
            onClick={handleMenuOpen}
            endIcon={<KeyboardArrowDownIcon />}
          >
            Linked Companies ({childOptions?.length})
          </Button>
        )}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          MenuListProps={{
            sx: { width: anchorEl ? anchorEl.clientWidth : 'auto' },
          }}
        >
          {user?.userInfo?.userData?.parentCompanyName && (
            <MenuItem
              onClick={() => {
                // setSelectedValue('')
                sessionStorage.setItem('sub-client', '')
                handleMenuClose()
              }}
              className={classes.menuItemFormatting}
            >
              <CorporateFareIcon className={classes.iconStyles} />
              <Typography variant='body1' fontWeight='bold'>
                {user?.userInfo?.userData?.parentCompanyName ||
                  user?.userInfo?.userData?.parentClientId}
              </Typography>
            </MenuItem>
          )}
          {childOptions?.map((option, index) => {
            return (
              <MenuItem
                className={classes.menuItemFormatting}
                key={index}
                onClick={() => {
                  // setSelectedValue(option.clientId)
                  setSessionStorageItem('sub-client', option?.clientId)
                  handleMenuClose()
                }}
              >
                {option?.companyName}
              </MenuItem>
            )
          })}
        </Menu>
      </div>
    </div>
  )
}

export default LinkedCompanies

const useStyles = makeStyles({
  linkedCompaniesMainContainer: {
    minWidth: '250px',
  },
  buttonUploadPersonal: {
    textTransform: 'unset !important',
    fontSize: '11px  !important',
    fontWeight: '600  !important',
    background: `${COLORS.DARK_PINK} !important`,
    color: `${COLORS.WHITE} !important`,
    margin: '0px !important',
    height: '24px !important',
    padding: '0px 10px !important',
    borderRadius: '6px !important',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: `${COLORS.DARK_PINK} !important`,
    },
    width: '100%',
  },
  childsDropdownContainer: { width: '100%', margin: '10px 0px' },
  menuItemFormatting: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    border: '1px solid lightgrey !important',
  },
  iconStyles: {
    marginRight: '5px !important',
    boxSizing: 'border-box',
  },
})
